import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
  FormGroup,
  FormControlLabel,
  Checkbox,Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import axios from "../../../../lib/axios";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const columns = [
  { id: 'RowNum', label: 'S.No.', minWidth: 170 },
  { id: 'FloorName', label: 'Floor Name', minWidth: 100 },
  { id: 'FloorAbrv', label: 'Abrv', minWidth: 100 },
  { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const Floor = () => {
  const [formData, setFormData] = useState({
    FloorName: '',
    FloorAbrv: '',
    Remark: ''
  });

  // const permissions = useModulePermissions("Floor Master");

  const [error, setError] = useState({
    FloorName: false,
    FloorAbrv: false
  });

  const navigate = useNavigate();

  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const location = useLocation();
  const [currentFloorId, setCurrentFloorId] = useState(null);
  const [mode, setMode] = useState('view');
  const [Status, setStatus] = useState("1");
  const [lastInsertedFloorId, setLastInsertedFloorId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const floorNameRef = useRef(null);
  const floorAbrvRef = useRef(null);
  const remarkRef = useRef(null);

  useEffect(() => {
    if (location.state && location.state.FloorId) {
      setCurrentFloorId(location.state.FloorId);
      fetchFloorData(location.state.FloorId);
      setMode('view');
    } else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchFloorData = async (id, flag) => {
    try {
      const response = await axiosInstance.post(`FloorMst/RetriveFloorMst`, {
        FloorId: parseInt(id),
        Flag: flag
      }
      );

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const floorData = response.data.Data[0];
        setFormData({
          FloorName: floorData.FloorName,
          FloorAbrv: floorData.FloorAbrv,
          Remark: floorData.Remark
        });
        setStatus(floorData.Status.toString() || "0");
        setIsFormDisabled(true);
        setCurrentFloorId(floorData.FloorId);
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch floor data');
      }
    } catch (error) {
      console.error('Error fetching floor data:', error);
      toast.error('Error fetching floor data. Please try again.');
    }
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };
  
      try {
        const res = await axios.post('FloorMst/getAllFloorMstDashBoard', { params });
  
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
  
    getRow();
  }, []);

  const handlePrevious = async () => {
    if (currentFloorId && currentFloorId > 1) {
      await fetchFloorData(currentFloorId, "P");
    }
  };

  const handleNext = async () => {
    if (currentFloorId) {
      await fetchFloorData(currentFloorId, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'Floor') {
      setFormData(prevState => ({
        ...prevState,
        state: ''
      }));
    }

    if (name === 'Floor' && value !== '') {
      setTimeout(() => {
        remarkRef.current.focus();
      }, 100000);
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (event.target === floorNameRef.current) {
        floorAbrvRef.current.focus();
      } else {
        remarkRef.current.focus();
      }
    }
  };

  const handleSave = async () => {

    let hasError = false;

    if (!formData.FloorName) {
      toast.error('FloorName is required');
      setError(prev => ({ ...prev, FloorName: true }));
      hasError = true;
    } else {
      setError(prev => ({ ...prev, FloorName: false }));
    }

    if (!formData.FloorAbrv) {
      toast.error('FloorAbrv is required');
      setError(prev => ({ ...prev, FloorAbrv: true }));
      hasError = true;
    } else {
      setError(prev => ({ ...prev, FloorAbrv: false }));
    }

    if (hasError) {
      return;
    }


    try {
      const payload = {
        FloorName: formData.FloorName,
        FloorAbrv: formData.FloorAbrv,
        Remark: formData.Remark,
        Status: Status
      };

      let response;
      if (mode === 'edit') {
        payload.FloorId = currentFloorId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axiosInstance.patch(`FloorMst/UpdateFloorMst`, payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axiosInstance.post(`FloorMst/InsertFloorMst`, payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === 'add') {
          setLastInsertedFloorId(response.data.Data)
          await fetchFloorData(response.data.Data);
          setMode('view');
          setIsFormDisabled(true);
          setCurrentFloorId(response.data.Data);
        } else {
          setMode('view');
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || 'Operation failed');
      }
    } catch (error) {
      console.error('Error saving/updating floor:', error);
      toast.error('Error saving/updating floor. Please try again.');
    }
  };

  const handleEdit = async () => {

    let Flag = await checkAndLock(currentFloorId, "MstFloor", "FloorId");
    switch (Flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);
    setFormData({
      FloorName: '',
      FloorAbrv: '',
      Remark: ''
    });
    setCurrentFloorId(null);

    setTimeout(() => {
      floorNameRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    try {
      await fetchFloorData(1, "L");
      await UnLock(currentFloorId, "MstFloor", "FloorId");
      setStatus("1");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error occurred while cancelling. Please try again.');
    }
  };

  const resetForm = () => {
    setFormData({
      FloorName: '',
      FloorAbrv: '',
      Remark: ''
    });
    setCurrentFloorId(null);
    setMode('view');
  };

  const handleExit = () => {
    navigate('/floortable')
  }

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {

    let Flag = await checkAndLock(currentFloorId, "MstFloor", "FloorId");
    switch (Flag) {
      case 0:
        setOpenConfirmDialog(false);
        await fetchFloorData(currentFloorId, "D");
        await fetchFloorData(currentFloorId, "N");
        setStatus("1");
        setMode('view');
        setIsFormDisabled(true);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });

    }

  };

  return (
    <>

      <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>

        <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
          <Grid item xs={12} className='form_title' 
            sx={{ 
              display: 'flex', alignItems: 'center', 
              justifyContent: 'space-between', marginTop: '20px',
              flexDirection: { xs: 'column', sm: 'row', md: 'row' }  
              }}
            >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                onClick={handlePrevious}
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentFloorId || currentFloorId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                // sx={{ margin: '0px 10px' }}
                className='three-d-button-next'
                onClick={handleNext}
                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentFloorId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            
            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              Floor Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName={"Floor Master"}
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className='form_field'>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={3}>
                <TextField
                  id="FloorName"
                  name="FloorName"
                  label={
                    <span>
                      Floor <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.FloorName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.FloorName}
                  helperText={error.FloorName && ""}
                  inputRef={floorNameRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={3}>
                <TextField
                  id="FloorAbrv"
                  name="FloorAbrv"
                  label={
                    <span>
                      Abrv <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.FloorAbrv}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.FloorAbrv}
                  helperText={error.FloorAbrv && ""}
                  inputRef={floorAbrvRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={3}>
                <TextField
                  id="Remark"
                  name="Remark"
                  label="Remark"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Remark}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={remarkRef}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={2}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === 'view' && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === 'edit' || mode === 'add') && (
              <>

                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>

              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
          columns={columns}
          rows={rows}
          title="Floor Master"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Floor